import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './index.less';

const FunctionTabs = ({ routes, type, autoRoute, location, history, withSearch, showOnSingleTab }) => {
	const prefixCls = 'eh-function-tabs';
	let activeTab = '';
	for (const route of routes) {
		if (location.pathname.indexOf(route.path) > -1 || route.path === location.pathname + location.search) {
			activeTab = route.path;
			break;
		}
	}
	const search = withSearch ? location.search : '';
	if (autoRoute && !activeTab && routes.length) {
		window.setTimeout(() => {
			history.replace(routes[0].path + search);
		}, 0);
	}
	const inManagement = location.pathname.split('/')[2] === 'management' || location.pathname.split('/')[3] === 'management';
	return !showOnSingleTab && !inManagement && routes.length === 1 ? null : (
		<div className={`${prefixCls} ${prefixCls}-${type}`}>
			<div className={`${prefixCls}-nav-container`}>
				<div className={`${prefixCls}-nav-wrap`}>
					<div className={`${prefixCls}-nav-scroll`}>
						<div className={`${prefixCls}-nav`}>
							{routes.map(({ name, path }, index) => (
								<Link key={index} to={path + search}>
									<div className={`${prefixCls}-tab ${path === activeTab && prefixCls + '-tab-active'}`}>
										<span>{name}</span>
									</div>
								</Link>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

FunctionTabs.propTypes = {
	// 路由
	routes: PropTypes.arrayOf(PropTypes.object).isRequired,
	// 页签的基本样式，可选 line、card 类型
	type: PropTypes.string,
	// 当前url匹配不到routes中的路由时，是否自动跳转到routes的第一项
	autoRoute: PropTypes.bool,
	// 点击tab切换路由时，是否带上当前的search
	withSearch: PropTypes.bool,
	//只有一个tab时，是否展示tab
	showOnSingleTab: PropTypes.bool,
};

FunctionTabs.defaultProps = {
	routes: [],
	type: 'line',
	autoRoute: true,
	withSearch: true,
	showOnSingleTab: false
};

export default withRouter(FunctionTabs);
